import { render } from "./UppyUploaderReplace.vue?vue&type=template&id=31d71ae2"
import script from "./UppyUploaderReplace.vue?vue&type=script&lang=js"
export * from "./UppyUploaderReplace.vue?vue&type=script&lang=js"

import "./UppyUploaderReplace.vue?vue&type=style&index=0&id=31d71ae2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UppyUploaderReplace.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31d71ae2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31d71ae2', __exports__)) {
    api.reload('31d71ae2', __exports__)
  }
  
  module.hot.accept("./UppyUploaderReplace.vue?vue&type=template&id=31d71ae2", () => {
    api.rerender('31d71ae2', render)
  })

}


export default __exports__